<mat-card>
    <mat-card-content>
        <form [formGroup]="priceResultForm" (ngSubmit)="onSubmit()">
            <div class="fons-gris">
                <h2>Días a contratar</h2>
                <mat-form-field appearance="outline" *ngIf="status === 1">
                    <mat-label>Fecha de inicio - fin del seguro</mat-label>
                    <!-- 👇 Usa formGroupName (no formControlName) -->
                    <mat-date-range-input [rangePicker]="pickerRange" formGroupName="datesRange">
                        <input matStartDate matInput formControlName="start" placeholder="Inicio" readonly>
                        <input matEndDate matInput formControlName="end" placeholder="Fin" readonly>
                    </mat-date-range-input>

                    <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerRange [startAt]="today"></mat-date-range-picker>
                </mat-form-field>
                <mat-error *ngIf="priceResultForm.get('datesRange.start')?.hasError('dateNotAfterToday')">
                    La fecha de inicio debe ser igual o posterior a hoy.<br /><br />
                </mat-error>
                <mat-error *ngIf="priceResultForm.get('datesRange.end')?.hasError('maxDuration')">
                    La duración máxima es de 30 días.<br /><br />
                </mat-error>
                <div class="info-detail">
                    <div class="info-detail-header">Información importante
                        <mat-icon *ngIf="expandedDetail != 'info'"
                            (click)="expandedDetail = 'info'">expand_more</mat-icon>
                        <mat-icon *ngIf="expandedDetail == 'info'" (click)="expandedDetail = ''">expand_less</mat-icon>
                    </div>
                    <div class="info-detail-content" *ngIf="expandedDetail == 'info'">
                        <p style="text-align: left;"><ng-container *ngIf="isStartInFuture; else activeNow">
                                El seguro es efectivo desde las 00h del {{ start_date | date }} a las 00 de {{ end_date
                                | date }}.
                            </ng-container>

                            <ng-template #activeNow>
                                El seguro es efectivo a partir del momento de contratación hasta la misma hora de {{
                                end_date |
                                date }}.
                            </ng-template>

                            Recuerda que también puedes contratar el seguro con antelación indicando la
                            fecha de inicio y fin del seguro, no es necesario que esperes al día antes de
                            necesitarlo.<br />
                            <b>IMPORTANTE:</b> Revisa bien la matrícula, ya que no será posible cambiarla una vez
                            contratado el
                            seguro.<br />
                            Más información en
                            <a href="https://www.coverpordias.es/seguro-temporal-condiciones" target="_blank">
                                condiciones especiales seguros por días
                            </a>.
                        </p>
                    </div>
                </div>

                <div class="plus_minus_wrapper">
                    <div class="plus_minus" (click)="addDuration(-1);">-</div>
                    <div class="days_counter">{{ durationDays }} días</div>
                    <div class="plus_minus" (click)="addDuration(1);">+</div>
                </div>
            </div>

            <div class="product-wrapper" *ngIf="stateData?.price_without_assistance">
                <div class="product-header">
                    <h3>Seguro a terceros</h3>
                    <div class="price-container">{{ stateData?.price_without_assistance?.primaTotal | number:'1.2-2' }}
                        €</div>
                </div>
                <div class="product-details">
                    Incluye:
                    <div class="product-detail" *ngFor="let detail of detailsData.all">
                        <div class="product-detail-header">{{ detail.title }}
                            <mat-icon *ngIf="expandedDetail != '1' + detail.id"
                                (click)="expandedDetail = '1' + detail.id">expand_more</mat-icon>
                            <mat-icon *ngIf="expandedDetail == '1' + detail.id"
                                (click)="expandedDetail = ''">expand_less</mat-icon>
                        </div>
                        <div class="product-detail-content" *ngIf="expandedDetail == '1' + detail.id">
                            <span [innerHTML]="detail.description"></span>
                        </div>
                    </div>
                </div>
                <button mat-button mat-raised-button color="primary" (click)="continue(false)">
                    Seleccionar
                </button>
            </div>

            <div class="product-wrapper" style="position: relative" *ngIf="stateData?.price_with_assistance && assistanceAvailable">
                <div class="product-header">
                    <h3>Seguro a terceros con asistencia</h3>
                    <div class="price-container">{{ stateData?.price_with_assistance?.primaTotal | number:'1.2-2'}} €
                    </div>
                </div>
                <div class="product-details">
                    Incluye:
                    <div class="product-detail" *ngFor="let detail of detailsData.all">
                        <div class="product-detail-header">{{ detail.title }}
                            <mat-icon *ngIf="expandedDetail != detail.id"
                                (click)="expandedDetail = detail.id">expand_more</mat-icon>
                            <mat-icon *ngIf="expandedDetail == detail.id"
                                (click)="expandedDetail = ''">expand_less</mat-icon>
                        </div>
                        <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                            <span [innerHTML]="detail.description"></span>
                        </div>
                    </div>
                    <div class="product-detail" *ngFor="let detail of detailsData.optional">
                        <div class="product-detail-header">{{ detail.title }}
                            <mat-icon *ngIf="expandedDetail != detail.id"
                                (click)="expandedDetail = detail.id">expand_more</mat-icon>
                            <mat-icon *ngIf="expandedDetail == detail.id"
                                (click)="expandedDetail = ''">expand_less</mat-icon>
                        </div>
                        <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                            <span [innerHTML]="detail.description"></span>
                        </div>
                    </div>
                </div>
                <button mat-button mat-raised-button color="primary" (click)="continue(true)"
                    style="position: relative; right: 0px;">
                    Seleccionar
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>